import { useMachine } from '@xstate/react';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import { Outlet } from 'react-router-dom';
import {
  onboardingMachine,
  OnboardingMachineContext,
} from 'components/onboarding/onboarding.machine';
import { FeatureHighlights } from 'components/onboarding/feature-highlights.component';
import { AccountSetupView } from 'components/onboarding/views/account-setup-view.component';
import { TextNotificationOptInView } from 'components/onboarding/views/text-notification-opt-in-view.component';
import { AccountSetupCompleteView } from 'components/onboarding/views/account-setup-complete-view.component';
import { BasePage } from 'components/base-page.component';
import { useGetScanUserProfile } from 'hooks/use-get-scan-user-profile/use-get-scan-user-profile.hook';
import { useErrorBoundary } from 'react-error-boundary';

const OnboardingViews = () => {
  const { showBoundary } = useErrorBoundary();
  const { isLoading } = useGetScanUserProfile();
  const { send } = OnboardingMachineContext.useActorRef();
  const snapshot = OnboardingMachineContext.useSelector(
    (machineSnapshot) => machineSnapshot,
  );

  if (
    isLoading ||
    snapshot.matches({ initializing: 'fetchUserProfileData' }) ||
    snapshot.matches({ accountSetup: 'setPostFTUX' })
  ) {
    return <LoadingIndicator />;
  }

  if (snapshot.matches('featureHighlights')) {
    return (
      <FeatureHighlights
        onOnboardingComplete={() => {
          send({ type: 'featureHighlightsCompleted' });
        }}
      />
    );
  }

  if (snapshot.matches({ accountSetup: 'accountSetup' })) {
    return <AccountSetupView />;
  }

  if (snapshot.matches({ accountSetup: 'textNotificationOptIn' })) {
    return <TextNotificationOptInView />;
  }

  if (snapshot.matches({ accountSetup: 'accountSetupCompleted' })) {
    return <AccountSetupCompleteView />;
  }

  if (snapshot.matches('error')) {
    showBoundary(new Error('Onboarding error'));
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return (
    <BasePage>
      <Outlet />
    </BasePage>
  );
};

export const Onboarding = () => {
  useMachine(onboardingMachine);

  return (
    <OnboardingMachineContext.Provider>
      <OnboardingViews />
    </OnboardingMachineContext.Provider>
  );
};
